module.exports = __webpack_public_path__ + "static/media/virtual-doc.21bbc4e3.svg";